import cx from 'classnames'
import React from 'react'

import { Arrow } from '@cinch/oxd-components/icons/src'
import SVG from '@cinch/oxd-components/svg/src'
import tokens from '@cinch/oxd-utils/tokens/src'

import * as styles from './accordion.module.css'

export interface AccordionProps {
  title: string
  aside?: React.ReactNode
  children?: React.ReactNode
  lozengeGroup?: React.ReactNode
  isExpanded: boolean
  toggleExpanded: () => void
  isDisabled?: boolean
}

const toId = (str: string) => str.replace(/\s/g, '-').toLowerCase()

const Accordion: React.FC<AccordionProps> = ({
  title,
  aside,
  children,
  lozengeGroup,
  toggleExpanded,
  isExpanded,
  isDisabled,
}) => {
  const accordianId = toId(`accordion-${title}`)

  return (
    <div className={styles.filterAccordion}>
      <div role="heading" aria-level={4} className={styles.heading}>
        <button
          className={cx(styles.button, { [styles.isExpanded]: isExpanded, [styles.isDisabled]: isDisabled })}
          onClick={toggleExpanded}
          aria-controls={accordianId}
          type="button"
          value={title}
          disabled={isDisabled}
        >
          <span className={styles.title}>{title}</span>
          {aside && <span className={styles.aside}>{aside}</span>}
          <span className={cx(styles.icon, { [styles.iconExpanded]: isExpanded, [styles.iconDisabled]: isDisabled })}>
            <SVG size={tokens.customProperties.font.size.xl} children={Arrow} />
          </span>
        </button>
      </div>
      <div aria-expanded={isExpanded} id={accordianId}>
        {isExpanded && <div className={styles.expandedContent}>{children}</div>}
      </div>
      {!isExpanded && lozengeGroup}
    </div>
  )
}

export default Accordion
